import type { TBankAuthConfig } from './socialNetworkUtils';

/**
 * Создание URL для авторизации TBank
 */
export const createTBankAuthUrl = (
  config: TBankAuthConfig,
  isWebView: boolean,
): string => {
  const validationState = String(Math.floor(Math.random() * 1000000000));

  // в webView добавляем текущий путь в state
  const state = isWebView
    ? `${validationState}|${window.location.pathname}`
    : validationState;

  const params = [
    'response_type=code',
    `client_id=${config.client_id}`,
    `redirect_uri=${window.location.origin}/login/tbank`,
    `state=${encodeURIComponent(state)}`,
    config.auth_token && `auth_token=${config.auth_token}`,
  ]
    .filter(Boolean)
    .join('&');

  const authUrl = ['https://id.tbank.ru/auth/authorize', params].join('?');

  return authUrl;
};
